module.exports = __webpack_public_path__ + "img/character_lanhou.94c78054.png";